import { memo, useState } from "react";
import { EnvironmentOutlined } from "@ant-design/icons";

// Image cover with a branded gradient fallback, optional stacked corner actions
// (a badge and/or an extra action node), and an optional image click handler.
const Cover = ({ src, alt, title, badge, onBadgeClick, action, onImageClick, height = 170 }) => {
    // An empty/missing url or a load error falls back to a branded gradient
    // placeholder instead of the browser's broken-image icon.
    const [errored, setErrored] = useState(false);
    const showImage = Boolean(src) && !errored;
    const clickable = onImageClick ? "jw-cover-clickable" : "";

    return (
        <div className="jw-cover" style={{ height }}>
            {showImage ? (
                <img
                    src={src}
                    alt={alt}
                    className={clickable}
                    style={{ height }}
                    onError={() => setErrored(true)}
                    onClick={onImageClick}
                />
            ) : (
                <div
                    className={`jw-cover-fallback ${clickable}`}
                    style={{ height }}
                    role="img"
                    aria-label={alt}
                    onClick={onImageClick}
                >
                    <EnvironmentOutlined />
                </div>
            )}
            <div className="jw-cover-overlay" />
            {(action || badge != null) && (
                <div className="jw-cover-actions">
                    {action}
                    {badge != null && (
                        onBadgeClick ? (
                            <button type="button" className="jw-badge jw-badge-btn" onClick={onBadgeClick}>
                                {badge}
                            </button>
                        ) : (
                            <span className="jw-badge">{badge}</span>
                        )
                    )}
                </div>
            )}
            {title && <div className="jw-cover-title">{title}</div>}
        </div>
    );
};

export default memo(Cover);
